import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../constants/typography';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  totalLabel: { marginTop: '16px' },
  noMatchesLabel: {
    color: theme.palette.black,
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
  },
  resultsLabel: {
    color: theme.palette.darkGrey,
    fontWeight: isKiteUser ? FONT_WEIGHT_REGULAR : FONT_WEIGHT_SEMIBOLD,
    fontSize: '16px',
    lineHeight: '20px',
  },
  emptyOrdersContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    height: 'calc(100vh - 344px)',
  },
  emptyOrdersHistory: {
    marginBottom: theme.spacing(5),
    width: 540,
    [theme.breakpoints.down('md')]: {
      width: 290,
    },
  },
  emptyOrdersHistoryButton: {
    width: 146,
    minHeight: 46,
    [theme.breakpoints.down('lg')]: {
      width: 170,
      minHeight: 44,
    },
  },
}));
